// @flow
import BaseComponent from '../base_component/base_component';
import offlineHandler from '../../assets/javascripts/offline_handler';

export default class UserPanel extends BaseComponent {
    minimised: ?boolean;
    $userPanel: JQuery;

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);

        this.minimised = options.minimised || window.innerWidth < 768;
        this.$userPanel = $(this.component).find('.user-panel');

        if (this.minimised) {
            this.$userPanel.toggleClass('minimised', this.minimised);
        }
        setTimeout(() => this.$userPanel.removeClass('loading'), 10);
        let resizeTimer, width = window.innerWidth, delay = 500;
        $(window).on('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if ((width < 768 && window.innerWidth >= 768 && this.minimised) ||
                    (window.innerWidth < 768 && width >= 768 && !this.minimised)) {
                        this.toggle()
                }
                width = window.innerWidth
            }, 150);
        });
        if(!options.disable_resize) {
            $(this.component).find('.user-panel__minimise').click(() => this.toggle());
        }
    }

    loadPage(pageName: string) {
        if(navigator.onLine) {
            window.loadPage(pageName);
        } else {
            window.location.href = `/${pageName}`
        }
        return false;
    }

    functions() {
        return {
            selectPage: (name: string) => this.setSelected(name),
            onOnline: () => this.setOnline(),
            onOffline: () => this.setOffline()
        }
    }

    toggle(isOpen: ?boolean) {
        this.minimised = isOpen == null ? !this.minimised : !isOpen;
        this.$userPanel.toggleClass('minimised', this.minimised);
        setTimeout(() => $(window).trigger('resize'), 500);
    }

    setSelected(menuItem: string) {
        this.$userPanel.find('[data-page].active').removeClass('active');
        this.$userPanel.find(`[data-page="${menuItem}"]`).addClass('active');
    }

    setOnline() {
        this.find('.nav-pill').removeClass('offline');
    }

    async setOffline() {
        if (!('serviceWorker' in navigator)) return;

        const cachedPages = await offlineHandler.getCachedPages();
        this.find('[data-page]').each((i: number, element: Element) => {
            let $element = $(element);
            if (!cachedPages.includes($element.attr('data-page'))) {
                $element.addClass('offline');
            }
        });
    }
}
